/** @jsxImportSource theme-ui */

import { ThemeUIStyleObject } from "theme-ui";
import { selectHideFretboardCircles } from "../../redux/guessNoteSlice";
import { useAppSelector } from "../../redux/hooks";

const FretboardSvg: React.FunctionComponent = () => {

  const hideCircles = useAppSelector(selectHideFretboardCircles);
  
  const style : ThemeUIStyleObject = {
    width: "100%",
    height: "auto",
    display: 'block',
    ...(hideCircles && {'& circle' : {display:'none'}})
  }
  
  
  return (
    <svg
      sx={style}
      id="fretboard"
      viewBox="0 0 1020 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        width="1012"
        height="256"
        rx="17"
        fill="url(#paint0_linear_2025_1202)"
      />
      <rect x="87" width="2" height="256" fill="#A8A8A8" />
      <rect x="171" width="2" height="256" fill="#A8A8A8" />
      <rect x="256" width="2" height="256" fill="#A8A8A8" />
      <rect x="340" width="2" height="256" fill="#A8A8A8" />
      <rect x="425" width="2" height="256" fill="#A8A8A8" />
      <rect x="509" width="2" height="256" fill="#A8A8A8" />
      <rect x="594" width="2" height="256" fill="#A8A8A8" />
      <rect x="678" width="2" height="256" fill="#A8A8A8" />
      <rect x="763" width="2" height="256" fill="#A8A8A8" />
      <rect x="847" width="2" height="256" fill="#A8A8A8" />
      <rect x="932" width="2" height="256" fill="#A8A8A8" />
      <circle cx="384" cy="128" r="11" fill="#C4C4C4" />
      <circle cx="215" cy="128" r="11" fill="#C4C4C4" />
      <circle cx="553" cy="128" r="11" fill="#C4C4C4" />
      <circle cx="722" cy="128" r="11" fill="#C4C4C4" />
      <circle cx="975" cy="91" r="11" fill="#C4C4C4" />
      <circle cx="975" cy="164" r="11" fill="#C4C4C4" />
      <g filter="url(#filter0_d_2025_1202)">
        <rect x="4" y="19" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <g filter="url(#filter1_d_2025_1202)">
        <rect x="4" y="62" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <g filter="url(#filter2_d_2025_1202)">
        <rect x="4" y="105" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <g filter="url(#filter3_d_2025_1202)">
        <rect x="4" y="148" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <g filter="url(#filter4_d_2025_1202)">
        <rect x="4" y="191" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <g filter="url(#filter5_d_2025_1202)">
        <rect x="4" y="234" width="1012" height="2" fill="#C4C4C4" />
      </g>
      <defs>
        <filter
          id="filter0_d_2025_1202"
          x="0"
          y="19"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2025_1202"
          x="0"
          y="62"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2025_1202"
          x="0"
          y="105"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_2025_1202"
          x="0"
          y="148"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_2025_1202"
          x="0"
          y="191"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_2025_1202"
          x="0"
          y="234"
          width="1020"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2025_1202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2025_1202"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2025_1202"
          x1="21"
          y1="19.5001"
          x2="996.5"
          y2="235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E2623" />
          <stop offset="1" stopColor="#715450" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FretboardSvg;
